export default __webpack_public_path__ + "static/media/Refer-a-friend-picture_480x270.5980fe37.jpg";